import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BIZ, track } from "../data/site";
import { Reveal } from "./Reveal";

export const CtaBlock = ({ heading = "Ready To Restore It?", sub = "Free estimates, direct insurance handling, and a written lifetime warranty on every repair." }) => (
  <Reveal>
    <div data-testid="cta-block" className="relative overflow-hidden rounded-2xl border border-accent/25 bg-gradient-to-br from-accent/[0.1] via-surface to-surface p-8 sm:p-12 text-center noise-overlay">
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 h-52 w-52 rounded-full bg-accent/10 blur-3xl" aria-hidden="true" />
      <h2 className="relative font-display text-2xl sm:text-4xl font-bold tracking-tight text-white text-balance">{heading}</h2>
      <p className="relative mt-4 max-w-xl mx-auto text-sm sm:text-base text-slate-300">{sub}</p>
      <div className="relative mt-8 flex flex-col sm:flex-row justify-center gap-4">
        <Link
          to="/free-estimate"
          data-testid="cta-estimate-btn"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-accentdeep px-8 py-4 font-display font-bold text-sm sm:text-base text-white transition-all duration-300 hover:bg-accenthover hover:-translate-y-0.5"
        >
          Get a Free Estimate
          <span aria-hidden="true">&rarr;</span>
        </Link>
        <a
          href={BIZ.phoneHref}
          data-testid="cta-call-btn"
          onClick={() => track("click_to_call", { location: "cta_block" })}
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/[0.04] px-8 py-4 font-display font-semibold text-sm sm:text-base text-white transition-all duration-300 hover:border-accent/60 hover:text-accent hover:-translate-y-0.5"
        >
          <Phone size={16} strokeWidth={2.2} />
          Call {BIZ.phoneDisplay}
        </a>
      </div>
    </div>
  </Reveal>
);
